<div class="app-layout">
  <!-- `inert`, not just width 0: a collapsed sidebar keeps its links focusable
       inside a zero-width overflow-hidden container unless the subtree is also
       taken out of the tab order and the a11y tree. -->
  <app-sidebar
    [class.is-collapsed]="sidebarCollapsed()"
    [attr.inert]="sidebarCollapsed() ? '' : null"
  />
  <div class="right-area">
    <app-header
      [quickStartOpen]="quickStartOpen()"
      [quickStartPending]="quickStartPending()"
      [sidebarCollapsed]="sidebarCollapsed()"
      (toggleSidebar)="toggleSidebar()"
      (toggleQuickStart)="toggleQuickStart()"
    />
    <div class="content-wrapper">
      <main class="content-area">
        <router-outlet />
      </main>
      <!-- `inert`, not `aria-hidden`: the closed panel keeps width 0 and stays mounted
           for the CSS exit animation, so its buttons remain focusable unless the whole
           subtree is taken out of the tab order as well as the a11y tree. -->
      <aside
        class="quick-start-panel"
        [class.is-open]="quickStartOpen()"
        [attr.inert]="quickStartOpen() ? null : ''"
      >
        <app-quick-start-guide [open]="quickStartOpen()" (closed)="closeQuickStart()" (pendingChange)="quickStartPending.set($event)" />
      </aside>
    </div>
  </div>
  <app-toast />
  <app-session-popup />
  <app-edit-account [open]="auth.editAccountOpen()" (closed)="auth.editAccountOpen.set(false)" />
</div>
